<template>
    <div class="dw-module-list">
        <div>
            <div class="dw-explorer-list">
                <table v-if="realTimeData" cellpadding="0" cellspacing="0" class="item-list" style="max-width: 600px">
                    <thead class="header">
                        <tr class="row" data-border="true">
                            <td class="cel">
                                <div class="item"><strong>Parametro</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item"><strong>Valore</strong></div>
                            </td>
                        </tr>
                    </thead>
                    <tbody class="tbody">
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Timestamp</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ formatDateTimeOffset(realTimeData.timestamp) }}</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Sofware_Version</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.sofware_Version }}</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>MAC_Address</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.maC_Address }}</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Machine_Time</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ formatSeconds(realTimeData.machine_Time) }}</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Therapy_Time_Main</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ formatSeconds(realTimeData.therapy_Time_Main) }}</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Therapy_Time_Side</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ formatSeconds(realTimeData.therapy_Time_Side) }}</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Machine_Status</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.machine_Status }}</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Use_Mode</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.use_Mode }}</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Optical_Peak_Power</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.optical_Peak_Power }} W</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Optical_Avg_Power</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.optical_Avg_Power }} W</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Elect_Peak_Power</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.elect_Peak_Power }} VA</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Elect_Avg_Power</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.elect_Avg_Power }} VA</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Shot_Energy</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.shot_Energy }} mJ</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Flow_Power</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.flow_Power }}</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Flow_Mode</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.flow_Mode }}</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Emission_Mode</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.emission_Mode }}</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Working_Mode</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.working_Mode }}</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Avx_Mode</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.avx_Mode }}</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Frequency</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.frequency }} Hz</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Emitted_Energy</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.emitted_Energy }} J</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Emitted_Shots</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.emitted_Shots }}</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>T_Machine</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.t_Machine }} °C</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>T_App_Main</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.t_App_Main }} °C</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>T_App_Side</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.t_App_Side }} °C</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>T_Handpiece</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.t_Handpiece }} °C</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>T_Probe_1</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.t_Probe_1 }} °C</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>T_Probe_2</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.t_Probe_2 }} °C</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>T_Probe_3</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.t_Probe_3 }} °C</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>T_Probe_4</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.t_Probe_4 }} °C</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>T_Probe_5</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.t_Probe_5 }} °C</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>T_Probe_6</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.t_Probe_6 }} °C</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>T_Probe_7</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.t_Probe_7 }} °C</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Bypass_Handpiece</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.bypass_Handpiece }}</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Main_Accessory</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.main_Accessory }}</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Side_Accessory</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.side_Accessory }}</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Serial_Num_Handpiece</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.serial_Num_Handpiece }}</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Shots_Handpiece</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.shots_Handpiece }}</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Interlock</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.interlock }}</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Footswitch</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.footswitch }}</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Fingerswitch</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.fingerswitch }}</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Patient_Button</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.patient_Button }}</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Coupling</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.coupling }}</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Water_Tank_Pres</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.water_Tank_Pres }}</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Water_Tank_Full</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.water_Tank_Full }}</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Compressor_Status</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.compressor_Status }}</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Precooling</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.precooling }}</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Defrost</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.defrost }}</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Battery_Status</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.battery_Status }}</div>
                            </td>
                        </tr>
                        <tr class="row" data-hover="true" data-cursor="default" data-border="true">
                            <td class="cel" data-group="true">
                                <div class="item"><strong>Battery_In_Charge</strong></div>
                            </td>
                            <td class="cel" data-align="right">
                                <div class="item">{{ realTimeData.battery_In_Charge }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, computed, watch, onBeforeMount } from "vue";
import { useStore } from "vuex";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";

defineExpose({ getModuleData });

const store = useStore();

const realTimeData = ref<any>(null);
const validationErrors = ref<any[]>([]);
const realTimeNav = ref<string | null>(null);
const realTimeDataInterval = ref<any>(null);

const navigationContext = computed(() => {
    return store.getters["navigationStore/navigationContext"];
});

const itemIdMaster = computed(() => {
    return store.getters["itemStore/itemIdMaster"];
});

watch(navigationContext, () => {
    getData();
});

onBeforeMount(async () => {
    await getData();

    setRealTimeDataInterval();
});

async function getData() {
    validationErrors.value = [];

    try {
        let response = await Axios.post("/dataweb/api/module/moduledevicetelemetry/getdata?nav=" + navigationContext.value.nav);

        realTimeData.value = response.data.realTimeData;
    } catch (error) {
        if (error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }
}

function setRealTimeDataInterval() {
    realTimeNav.value = navigationContext.value.nav;
    const interval = 5 * 1000; // 5 seconds
    realTimeDataInterval.value = setInterval(function () {
        if (navigationContext.value.nav != realTimeNav.value) {
            clearInterval(realTimeDataInterval.value);
        } else {
            getData();
        }
    }, interval);
}

function getModuleData() {
    let moduleData = { isCompleted: true };
    return moduleData;
}

function formatDateTimeOffset(dateItem: string): string {
    if (dateItem == null) {
        return "";
    }

    let date = new Date(dateItem);
    return date.toLocaleString((<any>window).App.userCulture, {
        day: "numeric",
        month: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit"
    });
}

function formatSeconds(seconds: number): string {
    let hours: any = Math.floor(seconds / 3600);
    let minutes: any = Math.floor((seconds - (hours * 3600)) / 60);

    if (hours < 10) { hours = "0" + hours; }
    if (minutes < 10) { minutes = "0" + minutes; }
    return hours + ":" + minutes;
}
</script>